<template>
<div>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 sm12 md4>
                <v-card outlined class="pa-2 pb-5">
                    <v-layout row wrap fill-height class="light-bg pa-2">
                        <v-flex>
                            <p class="text-color pb-0">Vendor Details</p>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <div>
                            <v-layout row wrap>
                                <v-flex xs12 class="p-5">
                                    <v-flex v-if="vendor_details.image">
                                        <v-img :src="storage_path()+vendor_details.image.path" max-width="150" max-height="150"></v-img>
                                    </v-flex>
                                    <v-flex v-else>
                                        <v-img src="@/assets/images/index.png" max-width="150" max-height="150"></v-img>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <h3 class="text-color mt-2">{{ vendor_details.name |capitalize}}</h3>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense class="pb-2">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                                            <v-list-item-title v-if="vendor_details.mobile!=null">{{this.vendor_details.mobile}}</v-list-item-title>
                                            <v-list-item-title v-else>-</v-list-item-title>
                                        </v-list-item-content>
                                          <v-list-item-content>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            <v-list-item-title v-if="vendor_details.email!=null">{{this.vendor_details.email}}</v-list-item-title>
                                            <v-list-item-title v-else>-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="pt-1"></v-divider>
                                    <v-list-item dense>
                                         <v-list-item-content>
                                            <v-list-item-subtitle>Created At</v-list-item-subtitle>
                                            <v-list-item-title v-if="vendor_details.created_at!=null">{{formatDateTime(this.vendor_details.created_at)}}</v-list-item-title>
                                            <v-list-item-title v-else>-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md8>
                <v-card outlined class="pa-2 pb-5">
                    <v-layout row class="">
                        <v-flex s12>
                            <v-tabs slider-color="maroon">
                                <v-tab ripple>
                                    <p class="text-color">Visitors</p>
                                </v-tab>
                                <v-tab ripple>
                                    <p class="text-color">Visits</p>
                                </v-tab>
                                <v-tab-item>
                                    <v-card flat class="pt-5">
                                        <!-- visitors -->
                                         <v-data-table :headers="visitor_headers"
                                         :items="visitor_details"
                                         class="elevation-0" 
                                         :loading="is_loading" 
                                         :options.sync="options" 
                                         :server-items-length="total_items" 
                                         :footer-props="{'items-per-page-options': [5,10,20,40,80]}"
                                         :items-per-page="5">
                                            <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                                                <tbody>
                                                    <tr v-for="item in items" :key="item.id">
                                                        <td v-if="item.image">
                                                            <v-avatar size="36">
                                                                <img :src="storage_path()+item.image.path">
                                                            </v-avatar>

                                                        </td>
                                                        <td v-else>
                                                            <v-avatar size="36">
                                                                <img src="@/assets/images/index.png">
                                                            </v-avatar>
                                                        </td>
                                                        <td v-if="item.name">{{ item.name}}</td><td v-else>-</td>
                                                        <td v-if="item.mobile">{{ item.mobile}}</td><td v-else>-</td>
                                                        <td v-if="item.email">{{ item.email}}</td><td v-else>-</td>
                                                        <td v-if="item.created_at">{{ formatDateTime(item.created_at)}}</td><td v-else>-</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                                        </v-data-table>   
                                        <!-- visitors -->
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat class="pt-5">
                                        <!-- visit -->
                                      <v-data-table 
                                        :headers="visit_headers" 
                                        :items="visit_details"
                                        item-key="id" 
                                        class="elevation-1" 
                                        :loading="is_loading" 
                                        :options.sync="options" 
                                        :server-items-length="total_items"
                                         :items-per-page="15">
                                            <template v-slot:body="{ items }" v-if="!is_loading && count_visit!='0'">
                                                <tbody>
                                                    <tr v-for="item in items" :key="item.id">
                                                        <td v-if="item.image">
                                                            <v-avatar size="36">
                                                                <img :src="storage_path()+item.image.path" @click="fullWidthImage(item.image.path)">
                                                            </v-avatar>
                                                        </td>
                                                        <td v-else>
                                                            <v-avatar size="36">
                                                                <img src="@/assets/images/index.png">
                                                            </v-avatar>
                                                        </td>
                
                                                        <td v-if="item.id">{{visitor_name[visit_details.map(function(x) {return x.id; }).indexOf(item.id)]}}</td><td v-else>-</td>
                                                        <td v-if="item.time">{{ formatDateTime(item.time) }}</td><td v-else>-</td>
                                                        <td v-if="item.purpose">{{ item.purpose}}</td><td v-else>-</td>

                                                    </tr>
                                                </tbody>
                                            </template>
                                            <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                                        </v-data-table>  
                                        <!-- visit -->
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>

    <!-- Image Dialog -->
    <v-dialog
      v-model="image_dialog_box"
      max-width="290"
      max-height="290"
    >
      <v-card>
         <v-img :src="storage_path()+image_path" ></v-img> 
      </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    methods: {
        getVendorDetails: function () {
       this.is_loading=true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/vendors/` + this.$route.params.id)
                .then(response => {
                    if (response.data.status == 1) {
                        
                        this.vendor_details = response.data.vendor_details;
                        this.total_items = response.data.vendor_details.total;
                       
                        this.visitor_details = response.data.visitor_details;
                        this.count = this.visitor_details.length;
                        var total_visitor = Object.keys(this.visitor_details);
                        
                        if(this.visitor_details.length>0){
                            var i,j;
                        for (var i = 0; i <= total_visitor.length; i++) {
                            var total_visit = Object.keys(this.visitor_details[i].visits);
                            for (var j = 0; j < total_visit.length; j++) 
                            {   this.visitor_name.push(this.visitor_details[i].name);
                                this.visit_details.push(this.visitor_details[i].visits[j]); 
                                
                            }
                            
                        }
                        }

                        this.count_visit = this.visit_details.length;
                         this.is_loading= false;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.is_loading= false;
                }).finally(() => {

                });
        },
        fullWidthImage(item_image){
            
            this.image_dialog_box =true;
            this.image_path = item_image;
            
        },
        applycolumnfilter: function () {
            this.visit_headers = [{
                    text: 'Image',
                    align: 'left',
                    value: 'image',
                },
                 {
                    text: 'Name',
                    value: 'name',
                    sortable: false,
                },
                
                {
                    text: 'Visit Time',
                    value: 'time',
                    sortable: false,
                },
               
                {
                    text: 'Purpose',
                    value: 'purpose',
                    sortable: false,
                }
            ];
            this.visitor_headers = [{
                    text: 'Image',
                    align: 'left',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Mobile',
                    value: 'mobile',
                    sortable: false,
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'Created At',
                    value: 'created_at',
                    sortable: false,
                },
            ];
        } //applycolunm filter
    },

    data() {
        return {
            is_loading: false,
            total_items:0,
            options: {},
            count:'',
            count_visit:'',
            role: '',
            default_visitor_image: "/visits_images/index.png",
           
            visit_headers:[],
            visit_details:[],

            visitor_headers:[],
            visitor_details:[],
        
            visitor_name:[],

            vendor_details: {}, 
            image_dialog_box:false,
            image_path:"",
          
            
        }
    },

    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        this.getVendorDetails();
        this.applycolumnfilter();
    }
}
</script>
